import { getCurrentTheme } from '~/utils/holidayTheme';

export const Menu = () => {
  const theme = getCurrentTheme();
  const MenuComponent = theme.menu.component;
  return MenuComponent;
};
